var React = require('react');

function FacebookInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M17.5 0C7.83408 0 0 7.83408 0 17.5C0 27.1659 7.83408 35 17.5 35C27.1659 35 35 27.1659 35 17.5C35 7.83408 27.1659 0 17.5 0ZM22.294 10.7183H19.7606C19.3318 10.7183 18.7472 10.9131 18.7472 11.8096V14.1871H22.294L21.8653 18.2016H18.7472V29.6214H14.0312V18.1626H11.7706V14.1481H14.0312V11.5367C14.0312 9.66592 14.9276 6.78174 18.7862 6.78174H22.294V10.7183Z","fill":"#252525"}));
}

FacebookInline.defaultProps = {"width":"35","height":"35","viewBox":"0 0 35 35","fill":"none"};

module.exports = FacebookInline;

FacebookInline.default = FacebookInline;
